import { render } from "./dinein_component.vue?vue&type=template&id=2ca62651&scoped=true"
import script from "./dinein_component.vue?vue&type=script&lang=js"
export * from "./dinein_component.vue?vue&type=script&lang=js"

import "./dinein_component.vue?vue&type=style&index=0&id=2ca62651&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca62651"]])

export default __exports__